export const StepperFormConstants = {
  GET_FORM_DRAFT_REQUEST: "GET_FORM_DRAFT_REQUEST",
  GET_FORM_DRAFT_SUCCESS: "GET_FORM_DRAFT_SUCCESS",
  GET_FORM_DRAFT_ERROR: "GET_FORM_DRAFT_ERROR",

  SAVE_FORM_DRAFT_REQUEST: "SAVE_FORM_DRAFT_REQUEST",
  SAVE_FORM_DRAFT_SUCCESS: "SAVE_FORM_DRAFT_SUCCESS",
  SAVE_FORM_DRAFT_ERROR: "SAVE_FORM_DRAFT_ERROR",

  CLOSE_INFO_BUBBLE: "CLOSE_INFO_BUBBLE",
  SET_CURRENT_STEP: "SET_CURRENT_STEP"
};
